export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14460.718fcae9.jpg";